import "./Engineers.css";
import React, { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import { db } from "../../index";

const LoadingIndicator = () => (
  <div className="loading-indicator">
      <p>Загрузка...</p>
  </div>
);

const EmptyRequestsMessage = () => (
  <div className="empty-requests-message">
      <p>Данные не найдены <img src="./img/document-error.svg" alt="NotFoundData" /></p>
  </div>
);

export function Engineers() {
  const [engineers, setEngineers] = useState([]);
  const [loading, setLoading] = useState(true);

  const getEngineers = (allUsers) => {
    return Object.values(allUsers).filter((user) => user.role === "Инженер");
  };

  useEffect(() => {
    const usersRef = ref(db, "users");
    onValue(usersRef, (snapshot) => {
      const allUsers = snapshot.val();
      const engineersList = getEngineers(allUsers);
      setEngineers(engineersList);
      setLoading(false);
    });
  }, []);

  return (
    <div className="table__dispatcher">
      <h1>Инженеры</h1>
      <div className="items-table__list media-engineers">
        <span>Email</span>
        <span>Имя</span>
        <span>Телефон</span>
      </div>
      {loading ? (
        <LoadingIndicator />
      ) : engineers.length === 0 ? (
        <EmptyRequestsMessage />
      ) : (
        <div>
          {engineers.map((engineer) => (
            <div className="items-table__list items-table__disp" key={engineer.userID}>
              <div className="items-table__disp-holder">
                <p>{engineer.email}</p>
              </div>
              <div className="items-table__disp-holder">
                <p>{engineer.displayName || "Не указано"}</p>
              </div>
              <div className="items-table__disp-holder">
                <p>{engineer.phoneNumber || "Не указан"}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}